function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-wallet",
  "data-name": "Icon awesome-wallet",
  d: "M37.215,9.124H6.455A1.225,1.225,0,0,1,5.164,7.978,1.225,1.225,0,0,1,6.455,6.833H37.44a1.225,1.225,0,0,0,1.291-1.146A3.675,3.675,0,0,0,34.858,2.25H5.164A4.9,4.9,0,0,0,0,6.833V29.745a4.9,4.9,0,0,0,5.164,4.583h32.05c2.261,0,4.1-1.542,4.1-3.437V12.561C41.314,10.665,39.475,9.124,37.215,9.124ZM33.567,24.017a2.45,2.45,0,0,1-2.582-2.291,2.6,2.6,0,0,1,5.164,0A2.45,2.45,0,0,1,33.567,24.017Z",
  transform: "translate(0 -2.25)",
  fill: "#f86542"
});

var SvgIconAwesomeWallet = function SvgIconAwesomeWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.314,
    height: 32.078,
    viewBox: "0 0 41.314 32.078",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAwesomeWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-awesome-wallet.2d46fd8e.svg";
export { ForwardRef as ReactComponent };